import { pubPathNoTrailingSlash } from "@/config";

// Navigation via history API (preact-iso listens to popstate)
export function appRoute(url: string, replace?: boolean) {
  const fullUrl = prefixPubPath(url);
  if (replace) {
    window.history.replaceState(null, "", fullUrl);
  } else {
    window.history.pushState(null, "", fullUrl);
  }
  window.dispatchEvent(new PopStateEvent("popstate"));
}

// Full page load, replacing the current history entry. Use for auth
// transitions where the app should re-bootstrap with the new session instead
// of soft-navigating, and the originating page shouldn't stay in history.
export function hardRedirect(url: string) {
  window.location.replace(prefixPubPath(url));
}

// Guards against open redirects: only a same-origin relative path (single
// leading slash, no scheme, no protocol-relative "//") is safe to hand to
// window.location/appRoute/hardRedirect.
export function isSafeRedirectPath(value: string | null | undefined): boolean {
  if (!value || !value.startsWith("/") || value.startsWith("//")) {
    return false;
  }
  try {
    const resolved = new URL(value, "http://localhost");
    return resolved.origin === "http://localhost";
  } catch {
    return false;
  }
}

// Reads and validates a redirect target from a query string, returning null
// when absent or unsafe so every caller has an explicit fallback.
export function getSafeRedirectTarget(
  search: string | URLSearchParams,
  paramName = "redirectTo",
): string | null {
  const params =
    search instanceof URLSearchParams ? search : new URLSearchParams(search);
  const value = params.get(paramName);
  return isSafeRedirectPath(value) ? (value as string) : null;
}

export function prefixPubPath(path?: string): string {
  let patchedUrl = path;
  if (
    pubPathNoTrailingSlash &&
    patchedUrl &&
    !patchedUrl.startsWith(pubPathNoTrailingSlash)
  ) {
    const sep = !patchedUrl.startsWith("/") ? "/" : "";
    patchedUrl = `${pubPathNoTrailingSlash}${sep}${patchedUrl}`;
  }
  return patchedUrl ?? "";
}
